/**
 * Nova configuração de sistema. Os campos padrão (servidor, porta,
 * SSL, usuário e senha) ficam sempre visíveis — decisão do cliente:
 * o SMTP é a única configuração que o servidor consome, então o
 * editor de JSON genérico saiu da tela. O nome é único no banco e é
 * validado contra os existentes antes do salvar (a digitação livre
 * devolvia erro seco do servidor na duplicidade).
 */
import {
  CreateContextProvider,
  required,
  SaveButton,
  SimpleForm,
  TextInput,
  useCreateController,
  useGetList,
} from "react-admin";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import Grid from "@mui/material/Grid";
import { PageTopBreadcrumb } from "../../components/PageTopBreadcrumb";
import { SmtpValueInputs } from "./system-settings-util";

export const SystemSettingCreate = (props: any) => {
  const controller: any = useCreateController({
    resource: "system-settings/crud",
  });

  const { data: existing } = useGetList("system-settings/crud", {
    pagination: { page: 1, perPage: 100 },
    sort: { field: "name", order: "ASC" },
  });
  const taken = new Set(
    (existing ?? []).map((s: any) => String(s.name).toUpperCase())
  );
  const uniqueName = (value: any) =>
    value && taken.has(String(value).toUpperCase())
      ? "Já existe uma configuração com este nome"
      : undefined;

  return (
    <CreateContextProvider value={controller}>
      {/* toolbar={false}: Salvar sai do rodapé e vai para o topo */}
      <SimpleForm toolbar={false}>
        <PageTopBreadcrumb
          title="Configurações de Sistema"
          firstPath="/#/system-settings/crud"
          secondTitle="Novo"
          actions={<SaveButton type="button" label="Salvar" />}
        />
        <Card sx={{ padding: 2, marginBottom: 3, width: "100%" }}>
          <CardHeader title="Nova Configuração de Sistema" />
          <CardContent>
            <Grid container columnSpacing={2} rowSpacing={0.5}>
              <Grid item xs={12}>
                <TextInput
                  source="name"
                  label="Nome"
                  fullWidth
                  validate={[required(), uniqueName]}
                  helperText='Nome único — é por ele que o servidor encontra a configuração (o envio de e-mails usa o nome "SMTP")'
                />
              </Grid>
              <SmtpValueInputs />
              <Grid item xs={12}>
                <CardHeader
                  sx={{ padding: "6px 0 0" }}
                  subheader="Criação nova de SMTP passa a valer após reiniciar o servidor (ou após salvar uma edição) — diferente da edição, que recarrega na hora."
                  subheaderTypographyProps={{ fontSize: 12.5 }}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </SimpleForm>
    </CreateContextProvider>
  );
};
